import React from "react";
import { Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import BeerData from "./components/BeerData";

import {
  getBeersFromApi,
  getLanguagesFromApi,
  getPhotoTypesFromApi,
  getBrandsFromApi,
  getLanguagesTitlesFromData,
  getBeersGroupsFromData,
  getBeersTranslationsFromData,
} from "./services/fetch";
import "./App.css";

var parseString = require("xml2js").parseString;
let beersApi;
let languagesApi;
let photoTypesApi;
let brandsApi;
let groupsApi;
let beersTranslations

let selectInput;
let htmlElement;
let htmlElementBtn;
let selectInputGroup;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();

    this.state = {
      beers: [],
      languages: [],
      photoTypes: [],
      brands: [],
      search: "",
      select: [],
      selectGroups: [],
      langTitles: [],
      groups: [],
      showResults: false,
      dropdown: "",
      beersTranslations: [],
      isToggleOpen: false,
    };
    this.handleTextFilter = this.handleTextFilter.bind(this);
    this.handleSelectFilter = this.handleSelectFilter.bind(this);
    this.deleteSearch = this.deleteSearch.bind(this);
    this.handleGroupFilter = this.handleGroupFilter.bind(this);
    this.deleteSearchGroups = this.deleteSearchGroups.bind(this);
    this.handleSearchDropdown = this.handleSearchDropdown.bind(this);
    this.handleToggleDropdown = this.handleToggleDropdown.bind(this);
  }
  componentDidMount() {
    getBeersFromApi().then((data) => {
      
      parseString(data, function (err, result) {
        beersApi = result;
        
      });
      const beersData = beersApi.BeersAPI.items.map((i) => i.item);
      
      //console.log(this.props.match);
      const beersMap = beersData.map((i) => i.map((i) => i.$));
      const beersClear = beersMap.flat();

      this.setState({
        beers: beersClear,
      });
    });

    getLanguagesFromApi().then((lang) => {
      parseString(lang, function (err, res) {
        languagesApi = res;
      });
      const languagesData = languagesApi.Languages.items.map((i) => i.item);
      const languagesMap = languagesData.map((i) => i.map((i) => i.$));
      const languagesClear = languagesMap.flat();
      this.setState({
        languages: languagesClear,
      });
    });

    getPhotoTypesFromApi().then((photoTypes) => {
      parseString(photoTypes, function (err, res) {
        photoTypesApi = res;
      });
      //console.log("photoTypesApi", photoTypesApi);
      const photoTypesData = photoTypesApi.PhotoTypes.items.map((i) => i.item);
      const photoTypesMap = photoTypesData.map((i) => i.map((i) => i.$));
      const photoTypesClear = photoTypesMap.flat();
      this.setState({
        photoTypes: photoTypesClear,
      });
    });

    getBrandsFromApi().then((brands) => {
      parseString(brands, function (err, res) {
        brandsApi = res;
      });
      const brandsData = brandsApi.Brands.items.map((i) => i.item);
      const brandsMap = brandsData.map((i) => i.map((i) => i.$));
      const brandsClear = brandsMap.flat();
      this.setState({
        brands: brandsClear,
      });
    });
    getBeersGroupsFromData().then((groups) => {
      parseString(groups, function (err, res) {
        groupsApi = res;
      });
      const groupsData = groupsApi.beersGroups.items.map((i) => i.item);
      const groupsMap = groupsData.map((i) => i.map((i) => i.$));
      const groupsClear = groupsMap.flat();
      this.setState({
        groups: groupsClear,
      });
    });

    getLanguagesTitlesFromData().then((titleLang) => {
      this.setState({
        langTitles: titleLang,
      });
    });
    getBeersTranslationsFromData().then((data) => {
      parseString(data, function (err, result) {
        beersTranslations = result;
      });
      const beersTranslationsData = beersTranslations.BeersTranslations.items.map((i) => i.item);
      const beersTranslationsMap = beersTranslationsData.map((i) => i.map((i) => i.$));
      const beersTranslationsClear = beersTranslationsMap.flat();
      this.setState({
        beersTranslations: beersTranslationsClear,
      });
    });
  }
  handleTextFilter(event) {
    const textInput = event.currentTarget.value;
    this.setState({
      search: textInput,
      showResults: true,
    });
  }
  handleSelectFilter(ev) {
    htmlElement = ev.target;
    selectInput = ev.currentTarget.value;
    this.setState((prevState) => {
      return {
        select: prevState.select.find((i) => i === selectInput)
          ? prevState.select.filter((i) => i !== selectInput)
          : prevState.select.concat(selectInput),
        showResults: true,
      };
    });
    this.state.select.find((i) => i === selectInput)
      ? (htmlElement.className = "brands__btn")
      : (htmlElement.className = "brands__btn red");
  }
  handleGroupFilter(ev) {
    htmlElementBtn = ev.target;
    selectInputGroup = ev.currentTarget.value;
    this.setState((prevState) => {
      return {
        selectGroups: prevState.selectGroups.find((i) => i === selectInputGroup)
          ? prevState.selectGroups.filter((i) => i !== selectInputGroup)
          : prevState.selectGroups.concat(selectInputGroup),
        showResults: true,
      };
    });
    this.state.selectGroups.find((i) => i === selectInputGroup)
      ? (htmlElementBtn.className = "groups__btn")
      : (htmlElementBtn.className = "groups__btn red");
  }
  handleSearchDropdown(dropdown) {
    const dropInput = dropdown;
      this.setState({
        dropdown: dropInput,
      });
  }
  handleToggleDropdown(ev) {
    this.setState({
      isToggleOpen: !this.state.isToggleOpen,
    });
  }
  deleteSearch(selectButton) {
    this.setState({
      select: [],
    });
    for (let i = 0; i < selectButton.length; i++) {
      selectButton[i].className = "brands__btn";
    }
  }
  deleteSearchGroups(groupsButton) {
    this.setState({
      selectGroups: [],
    });
    for (let i = 0; i < groupsButton.length; i++) {
      groupsButton[i].className = "groups__btn";
    }
  }
 
  render() {
  
    const {
      beers,
      search,
      languages,
      brands,
      select,
      langTitles,
      showResults,
      groups,
      selectGroups,
      dropdown,
      beersTranslations,
      isToggleOpen,
      
    } = this.state;

    /** Funcion para convertir el valor en float */
    function parseToFloat(value) {
      if (typeof value !== 'string') return NaN;
      return parseFloat(value.replace(',', '.'));
    }
    
    /** Filtro Genérico para valores numéricos **/
    function filterNumeric(attribute, beers, search, dropdown, extraCondition) {
      const searchValue = parseToFloat(search);
    
      return beers.filter((beer) => {
        const beerValue = parseToFloat(beer[dropdown]);
        const nextInteger = Math.floor(searchValue + 1);
    
        if (searchValue === 0) {
          return (isNaN(beerValue) || beerValue === 0) && extraCondition(beer);
        }
    
        if (isNaN(beerValue)) {
          return false;
        }
    
        return beerValue >= searchValue && beerValue < nextInteger;
      }).sort((a, b) => {
        const aValue = parseToFloat(a[dropdown]);
        const bValue = parseToFloat(b[dropdown]);
        return aValue - bValue;
      });
    }
    
    /** Filtro para Alcohol  **/
    function filterAlcohol() {
      return filterNumeric('Alcohol', beers, search, dropdown, () => true);
    }
    
    /** Filtro para amargor */
    function filterAmargor() {
      return filterNumeric('Amargo', beers, search, dropdown, (beer) => !isNaN(parseToFloat(beer.Alcohol)));
    }
    
    function filterByLanguageAndSearch(filterFunc) {
      const searchUpper = search.toUpperCase();
      
      return new Set(
        beersTranslations
          .filter(i => i.Language === "es" && filterFunc(i, searchUpper))
          .map(i => i.BeerID)
      );
    }

    function filterTodosCampos() {
      return beers.filter(i =>
        filterByLanguageAndSearch((item, searchUpper) => 
        item.BeerName?.toUpperCase().includes(searchUpper) 
        || item.Descripcion?.toUpperCase().includes(searchUpper) 
        || item.NotaCataApariencia?.toUpperCase().includes(searchUpper) 
        || item.NotaCataSabor?.toUpperCase().includes(searchUpper)
        || item.Levadura?.toUpperCase().includes(searchUpper)
        || item.Estilo?.toUpperCase().includes(searchUpper) 
        || item.EscuelaEstilo?.toUpperCase().includes(searchUpper)).has(i.ID || i.BeerID)
      );
      
    }
    
    function filterNotaCata() {
      return beers.filter(i => 
        filterByLanguageAndSearch((item, searchUpper) => item.NotaCataApariencia?.toUpperCase().includes(searchUpper) || item.NotaCataSabor?.toUpperCase().includes(searchUpper)).has(i.ID || i.BeerID)
      );
    }
    
    function filterMateriasPrimas() {
      return beers.filter(i => 
        filterByLanguageAndSearch((item, searchUpper) => item[dropdown]?.toUpperCase().includes(searchUpper)).has(i.ID || i.BeerID)
      );
    }
    
    function filterGama(previousFilter) { 
      const seleccion = new Set();
      
      selectGroups.forEach(group => {
        previousFilter
          .filter(beer => beer.GroupID === group)
          .forEach(beer => seleccion.add(beer));
      });
      
      return Array.from(seleccion);
    }
    
    let filter = beers;
    if (search.trim().length > 0 && dropdown.trim().length > 0) {
      switch (dropdown) {
        case "Todos":
          filter = filterTodosCampos();
          break;
        case "NotaCata":
          filter = filterNotaCata();
          break;
        case "Amargo":
          filter = filterAmargor();
          break;
        case "Alcohol":
          filter = filterAlcohol();
          break;
        default:
          filter = filterMateriasPrimas();
          break;
      }
    } else {
      filter = filterTodosCampos();
    }
    
    if (selectGroups.length > 0 ) {
      filter = filterGama(filter);
    }  
      

    return (
      <div>
        <Header />
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              return (
                <Home
                  beers={filter}
                  handleTextFilter={this.handleTextFilter}
                  search={search}
                  brands={brands}
                  handleSelectFilter={this.handleSelectFilter}
                  select={select}
                  deleteSearch={this.deleteSearch}
                  showResults={showResults}
                  groups={groups}
                  handleGroupFilter={this.handleGroupFilter}
                  selectGroups={selectGroups}
                  deleteSearchGroups={this.deleteSearchGroups}
                  handleSearchDropdown={this.handleSearchDropdown}
                  dropdown={dropdown}
                  handleToggleDropdown={this.handleToggleDropdown}
                  isToggleOpen={isToggleOpen}
                />
              );
            }}
          />
          <Route
            path="/beer-detail/:beerID"
            render={(routerProps) => {
              return (
                <div id="pdf-print">
                  <BeerData
                    routerProps={routerProps}
                    beers={beers}
                    languages={languages}
                    brands={brands}
                    langTitles={langTitles}
                  />
                </div>
              );
            }}
          />
        </Switch>
      </div>
    );
  }
}


export default App;
